import { styled } from "@mui/material";

export default styled("div")`

    .details-card {
        padding:1em;
        margin: 1em 0 3em;
    }

    .chips-wrapper {
        div { margin-inline: 5px; }
    }

`;
